import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

export const UnpaidAgentsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.unpaidAgents.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
